import { MAX_ITEMS_IN_PAGE } from '../../actions/commonActions';

const initState = {
    mobileappbanners: [],
    mobileappbanner: {},
    currentPage: 1,
    totalPages: 0,
    numItems: 0,
    min: 1,
    max: MAX_ITEMS_IN_PAGE,
    mobileAppBannerFilter: ''
}

const mobileAppBannerReducer = (state = initState, action) => {
    switch (action.type) {
        case 'FETCH_MOBILE_APP_BANNERS':
            return {
                ...state,
                mobileappbanners: action.mobileappbanners
            }
        case 'SET_MOBILE_APP_BANNERS_PAGINATION':
            return {
                ...state,
                numItems: action.numItems,
                min: action.min,
                totalPages: action.totalPages,
                currentPage: typeof (action.currentPage) !== "undefined" ? action.currentPage : state.currentPage,
                max: action.max
            }
        case 'RESET_MOBILE_APP_BANNERS_PAGINATION':
            return {
                ...state,
                currentPage: 1,
                totalPages: 0,
                numItems: 0,
                min: 1,
                max: MAX_ITEMS_IN_PAGE
            }
        case 'MOBILE_APP_BANNER_FILTER':
            return {
                ...state,
                mobileAppBannerFilter: action.filter
            }
        case 'SET_MOBILE_APP_BANNER_FIELD_CHANGE':
            return {
                ...state,
                mobileappbanner: Object.assign(state.mobileappbanner, action.value)
            }
        case 'SET_MOBILE_APP_BANNER':
            return {
                ...state,
                mobileappbanner: action.mobileappbanner
            }
        case 'RESET_MOBILE_APP_BANNER':
            return {
                ...state,
                mobileappbanner: {}
            }
        default:
            return state;
    }
}

export default mobileAppBannerReducer
